import { FileBrowser } from "@/components/FileBrowser/FileBrowser";

export function BucketPage() {
  return <FileBrowser />;
}
